export const formatMrr = (mrr: number | undefined): string => {
  if (mrr === undefined || mrr === null) return 'N/A';
  if (mrr === 0) return '$0';
  if (mrr >= 1_000_000) return `$${(mrr / 1_000_000).toFixed(1)}M`;
  if (mrr >= 1_000) return `$${(mrr / 1_000).toFixed(1)}K`;
  return `$${mrr}`;
};

export const formatNumber = (n: number): string =>
  n.toLocaleString('en-US');
